"use strict";

var __awaiter = this && this.__awaiter || function (thisArg, _arguments, P, generator) {
  function adopt(value) {
    return value instanceof P ? value : new P(function (resolve) {
      resolve(value);
    });
  }

  return new (P || (P = Promise))(function (resolve, reject) {
    function fulfilled(value) {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    }

    function rejected(value) {
      try {
        step(generator["throw"](value));
      } catch (e) {
        reject(e);
      }
    }

    function step(result) {
      result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
    }

    step((generator = generator.apply(thisArg, _arguments || [])).next());
  });
};

var __generator = this && this.__generator || function (thisArg, body) {
  var _ = {
    label: 0,
    sent: function sent() {
      if (t[0] & 1) throw t[1];
      return t[1];
    },
    trys: [],
    ops: []
  },
      f,
      y,
      t,
      g;
  return g = {
    next: verb(0),
    "throw": verb(1),
    "return": verb(2)
  }, typeof Symbol === "function" && (g[Symbol.iterator] = function () {
    return this;
  }), g;

  function verb(n) {
    return function (v) {
      return step([n, v]);
    };
  }

  function step(op) {
    if (f) throw new TypeError("Generator is already executing.");

    while (_) {
      try {
        if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
        if (y = 0, t) op = [op[0] & 2, t.value];

        switch (op[0]) {
          case 0:
          case 1:
            t = op;
            break;

          case 4:
            _.label++;
            return {
              value: op[1],
              done: false
            };

          case 5:
            _.label++;
            y = op[1];
            op = [0];
            continue;

          case 7:
            op = _.ops.pop();

            _.trys.pop();

            continue;

          default:
            if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
              _ = 0;
              continue;
            }

            if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
              _.label = op[1];
              break;
            }

            if (op[0] === 6 && _.label < t[1]) {
              _.label = t[1];
              t = op;
              break;
            }

            if (t && _.label < t[2]) {
              _.label = t[2];

              _.ops.push(op);

              break;
            }

            if (t[2]) _.ops.pop();

            _.trys.pop();

            continue;
        }

        op = body.call(thisArg, _);
      } catch (e) {
        op = [6, e];
        y = 0;
      } finally {
        f = t = 0;
      }
    }

    if (op[0] & 5) throw op[1];
    return {
      value: op[0] ? op[1] : void 0,
      done: true
    };
  }
};

var __importStar = this && this.__importStar || function (mod) {
  if (mod && mod.__esModule) return mod;
  var result = {};
  if (mod != null) for (var k in mod) {
    if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
  }
  result["default"] = mod;
  return result;
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var react_1 = __importStar(require("react"));

var react_i18next_1 = require("react-i18next");

var formik_1 = require("formik");

var react_web_components_1 = require("@nimles/react-web-components");

var fields_1 = require("../fields");

var react_web_components_2 = require("@nimles/react-web-components");

var _1 = require(".");

exports.RequestQuoteForm = function (_a) {
  var vehicle = _a.vehicle,
      user = _a.user,
      product = _a.product,
      onVehicleSearch = _a.onVehicleSearch,
      onSubmit = _a.onSubmit,
      renderAttributes = _a.renderAttributes;
  var t = react_i18next_1.useTranslation().t;

  var _b = react_1.useState(),
      vehicleModalIsVisible = _b[0],
      setVehicleModalIsVisible = _b[1];

  var _c = react_1.useState(),
      productModalIsVisible = _c[0],
      setProductModalIsVisible = _c[1];

  var handleSubmit = function handleSubmit(values, _a) {
    var setSubmitting = _a.setSubmitting,
        setErrors = _a.setErrors,
        setStatus = _a.setStatus;
    return __awaiter(void 0, void 0, void 0, function () {
      var error_1;
      return __generator(this, function (_b) {
        switch (_b.label) {
          case 0:
            _b.trys.push([0, 2,, 3]);

            return [4
            /*yield*/
            , onSubmit(values)];

          case 1:
            _b.sent();

            setSubmitting(false);
            setStatus({
              success: true
            });
            return [3
            /*break*/
            , 3];

          case 2:
            error_1 = _b.sent();
            setStatus({
              success: false
            });
            setSubmitting(false);
            setErrors({
              submit: error_1.message
            });
            return [3
            /*break*/
            , 3];

          case 3:
            return [2
            /*return*/
            ];
        }
      });
    });
  };

  var values = {
    firstName: user && user.firstName || '',
    lastName: user && user.lastName || '',
    username: user && user.username || '',
    password: user && user.password || '',
    licensePlate: vehicle && vehicle.licensePlate || '',
    brand: vehicle && vehicle.brand || '',
    model: vehicle && vehicle.model || '',
    modelYear: vehicle && vehicle.modelYear || '',
    color: vehicle && vehicle.color || '',
    vehicleId: vehicle && vehicle.vehicleId || '',
    productGroupId: '',
    parts: '',
    address: '',
    city: '',
    postalCode: '',
    description: '',
    condition: {
      used: true,
      new: true,
      renovated: true
    },
    quality: {
      economic: true,
      original: true
    }
  };
  return react_1.default.createElement("div", null, react_1.default.createElement(formik_1.Formik, {
    initialValues: values,
    onSubmit: handleSubmit,
    render: function render(_a) {
      var values = _a.values,
          handleSubmit = _a.handleSubmit,
          isSubmitting = _a.isSubmitting,
          setFieldValue = _a.setFieldValue;
      return react_1.default.createElement("div", null, react_1.default.createElement("form", {
        onSubmit: handleSubmit,
        name: "simpleForm",
        className: "quote-request-form"
      }, react_1.default.createElement(react_web_components_1.Section, null, react_1.default.createElement(react_web_components_1.Container, null, react_1.default.createElement(react_web_components_1.DisplayField, {
        name: "Mitt valda fordon"
      }, vehicle && react_1.default.createElement("span", null, vehicle.brand, " ", vehicle.model, " - ", vehicle.modelYear, " -", ' ', vehicle.licensePlate), ' ', react_1.default.createElement("a", {
        onClick: function onClick() {
          return setVehicleModalIsVisible(true);
        }
      }, t(vehicle ? 'action.changeVehicle' : 'action.chooseVehicle'))))), react_1.default.createElement(react_web_components_1.Section, {
        color: "dark"
      }, react_1.default.createElement(react_web_components_1.Container, null, react_1.default.createElement(react_web_components_1.DisplayField, {
        name: "Jag s\xF6ker"
      }, product && react_1.default.createElement("span", null, "}", productModalIsVisible.name), ' ', react_1.default.createElement("a", {
        onClick: function onClick() {
          return setProductModalIsVisible(true);
        }
      }, t(product ? 'action.changeProduct' : 'action.chooseProduct'))), renderAttributes, react_1.default.createElement("div", {
        className: "quote-request-form__field"
      }, react_1.default.createElement(fields_1.TextAreaField, {
        name: "description",
        label: t('prop.description'),
        placeholder: t('prop.description'),
        value: values.description
      })))), react_1.default.createElement(react_web_components_1.Section, null, react_1.default.createElement(react_web_components_1.Container, null, user && user.username ? react_1.default.createElement("div", null, react_1.default.createElement("div", null, react_1.default.createElement("strong", null, user.firstName, " ", user.lastName)), react_1.default.createElement("div", null, user.username)) : react_1.default.createElement(react_1.Fragment, null, react_1.default.createElement(react_web_components_1.Row, null, react_1.default.createElement(react_web_components_1.Column, {
        flex: true
      }, react_1.default.createElement(fields_1.InputField, {
        required: true,
        name: "firstName",
        label: t('prop.firstName'),
        placeholder: t('prop.firstName'),
        value: values.firstName
      })), react_1.default.createElement(react_web_components_1.Column, {
        flex: true
      }, react_1.default.createElement(fields_1.InputField, {
        required: true,
        name: "lastName",
        label: t('prop.lastName'),
        placeholder: t('prop.lastName'),
        value: values.lastName
      }))), react_1.default.createElement(react_web_components_1.Row, null, react_1.default.createElement(react_web_components_1.Column, {
        flex: true
      }, react_1.default.createElement(fields_1.InputField, {
        required: true,
        name: "username",
        label: t('prop.email'),
        placeholder: t('prop.email'),
        value: values.username
      }))), react_1.default.createElement(react_web_components_1.Row, null, react_1.default.createElement(react_web_components_1.Column, {
        flex: true
      }, react_1.default.createElement(fields_1.InputField, {
        required: true,
        type: "phonenumber",
        name: "phonenumber",
        label: t('prop.phoneNumber'),
        placeholder: t('prop.phoneNumber'),
        value: values.phoneNumber
      })), react_1.default.createElement(react_web_components_1.Column, {
        flex: true
      }, react_1.default.createElement(fields_1.InputField, {
        required: true,
        name: "postalCode",
        label: t('prop.postalCode'),
        placeholder: t('prop.postalCode'),
        value: values.postalCode
      })))))), react_1.default.createElement(react_web_components_1.Section, null, react_1.default.createElement(react_web_components_1.Container, {
        className: "quote-request-form__end"
      }, react_1.default.createElement(react_web_components_1.Row, {
        justify: "center"
      }, react_1.default.createElement(react_web_components_1.Column, null, react_1.default.createElement(react_web_components_2.Button, {
        raised: true,
        type: "submit",
        disabled: isSubmitting,
        className: "quote-request-form__submit"
      }, t(isSubmitting ? 'action.requestingQuote' : 'action.requestQuote'))))))), onVehicleSearch && react_1.default.createElement(react_web_components_2.Modal, {
        open: vehicleModalIsVisible,
        onClose: function onClose() {
          return setVehicleModalIsVisible(false);
        }
      }, react_1.default.createElement(react_web_components_1.Section, {
        padding: true
      }, react_1.default.createElement("h2", null, t('action.chooseVehicle'), "..."), react_1.default.createElement(_1.LicensePlateForm, {
        dark: true,
        onSubmit: function onSubmit(licensePlate) {
          return __awaiter(void 0, void 0, void 0, function () {
            var vehicle;
            return __generator(this, function (_a) {
              switch (_a.label) {
                case 0:
                  return [4
                  /*yield*/
                  , onVehicleSearch(licensePlate)];

                case 1:
                  vehicle = _a.sent();
                  setFieldValue('brand', vehicle.brand);
                  setFieldValue('model', vehicle.model);
                  setFieldValue('modelYear', vehicle.modelYear);
                  setFieldValue('color', vehicle.color);
                  setVehicleModalIsVisible(false);
                  return [2
                  /*return*/
                  ];
              }
            });
          });
        }
      }))), react_1.default.createElement(react_web_components_2.Modal, {
        open: !vehicleModalIsVisible && productModalIsVisible,
        onClose: function onClose() {
          return setProductModalIsVisible(false);
        }
      }));
    }
  }));
};